export const BANNER_SLIDER_TYPES = {
  Static: 1,
  Manual: 2,
  Automatic: 3,
};

export const BANNER_TYPES = {
  MainBanner: 1,
  MultiBanner: 2,
};
